/**
 * @file base.js
 * @description Base of the theme scripts for the Shopify Theme-Inspire.
 * @copyright 2025 @InStijlTech
 *
 * This file serves as the entry point for initializing various theme scripts.
 * It imports and initializes different modules required for the theme's functionality.
 *
 * Base of the theme scripts
 * Import your scripts here
 * Example: import { log_jj } from './js-log-functions.js';
 *
 */

import { ismInitSwipers, ismSwiperChange } from './js-carousel.js';
import { ismInitMobileNav, ismInitDesktopNav } from './js-navigation.js';
import {
  initProductCardHover,
  initProductOptions,
  initRecommendations,
  initProductCardOptions,
  initProductAddToCart,
} from './js-product.js';
import { initLanguageSelector } from './js-language-selector.js';
import { addAnimationOnScroll } from './js-animate.js';
import { initFilters } from './js-filters.js';
import { initSearch } from './js-search.js';

const ISM_init = () => {
  ismInitSwipers();
  ismInitMobileNav();
  ismInitDesktopNav();
  ismSwiperChange();
  initProductCardHover();
  initProductOptions();
  initProductCardOptions();
  initProductAddToCart();
  initFilters();
  initRecommendations();
  addAnimationOnScroll();
  initSearch();
  initLanguageSelector();
};

document.addEventListener('DOMContentLoaded', ISM_init);

// Shopify design mode
const hideModalsInDesignMode = (event) => {
  const modal = event.target.querySelector('.modal');
  if (modal) {
    const bsModal = bootstrap.Modal.getInstance(modal);
    if (bsModal) {
      bsModal.hide();
    }
  }

  const offcanvas = event.target.querySelector('.offcanvas');
  if (offcanvas) {
    const bsOffcanvas = bootstrap.Offcanvas.getInstance(offcanvas);
    if (bsOffcanvas) {
      bsOffcanvas.hide();
    }
  }
};

const showModalsInDesignMode = (event) => {
  const modal = event.target.querySelector('.modal');
  if (modal) {
    const bsModal = new bootstrap.Modal(modal);
    bsModal.show();
  }

  const offcanvas = event.target.querySelector('.offcanvas');
  if (offcanvas) {
    const bsOffcanvas = new bootstrap.Offcanvas(offcanvas);
    bsOffcanvas.show();
  }
};

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    console.info('Shopify Section Loaded', event);
    ISM_init();
  });

  document.addEventListener('shopify:section:unload', (event) => {
    hideModalsInDesignMode(event);
  });

  document.addEventListener('shopify:section:select', (event) => {
    setTimeout(() => {
      showModalsInDesignMode(event);
    }, 500);
  });

  document.addEventListener('shopify:section:deselect', (event) => {
    hideModalsInDesignMode(event);
  });

  document.addEventListener('shopify:block:select', (event) => {
    const block = event.target;
    const swiperEl = block.closest('.swiper');

    if (swiperEl && swiperEl.swiper) {
      const swiper = swiperEl.swiper;
      const slideIndex = Array.from(swiperEl.querySelectorAll('.swiper-slide')).indexOf(block);

      if (slideIndex !== -1) {
        swiper.slideTo(slideIndex);
      }
    }
  });
}

setTimeout(() => {
  if (window.location.href.indexOf('127.0.0.1:9292') !== -1) {
    document.getElementById('shopify-pc__banner').style.display = 'none';
  }
}, 500);
